
<div class="panel-body ">
        <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top" *ngIf="(relatedEvents.length === 0)">
            <div class="panel-title">
                Related Events
            </div>
            <div class="panel-body ">
                No Related Events information available for this allegation.
            </div>
        </div>
    <!-- <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top" *ngIf="(relatedEvents.length === 0)">
        No Related Events information available for this allegation.
    </div> -->
    <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top" *ngIf="(relatedEvents.length !== 0)">
      <div class="panel-title">
        Related Events
      </div>
     <div class="panel-body ">
       <div class="row table-responsive">
      <table id="relatedAllegations-table" class="table table-condensed table-striped">
     <thead>
       <tr>
        <th id="V122c">
          <span class="field-code ">V122c json='allegations.date'</span>
          Date <br> 
          <span class="field-code ">V122c json='allegations.time'</span>
          Time
        </th>
        <th id="V121c">
          <span class="field-code ">V121c json='allegations.event'</span>
            Event <br>
            <span class="field-code ">V121c json='allegations.type'</span>
            Type <br>
            <span class="field-code ">V121c json='allegations.outcome'</span>
            Outcome
        </th>
        <th id="V122c">
          <span class="field-code ">V122c json='allegations.judge'</span>
          Judge <br> 
          <span class="field-code ">V122c json='allegations.courtroom'</span>
          Courtroom
        </th>
        </tr>
     </thead>
     <tbody *ngFor="let relatedEvent of relatedEvents; let i = index">
        <tr>
         <td id="{{'civil-caseDetails-attorneys-' + i + '-dateTime' }}">{{relatedEvent.getDate() | date:'MM/dd/yyyy'}} <br> {{relatedEvent.getTime()}}</td>
         <td id="{{'civil-caseDetails-attorneys-' + i + '-eventTypeOutcome'}}">{{relatedEvent.getEventDesc()}} <br> {{relatedEvent.getTypeDesc()}} <br> {{relatedEvent.getEventOutcomeDesc()}} </td>
         <td id="{{'civil-caseDetails-attorneys-' + i + '-result'}}">{{relatedEvent.getPresidingJudgeName()}} <br> 
          <!-- {{relatedEvent.getCourtRoomCode()}} - {{relatedEvent.getCourtRoom()}} -->
          {{relatedEvent.getLocationId()}}</td>         
       </tr>   

     </tbody>
     </table>
     </div>
    </div>
   </div>
 </div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations-additional-info/related-events/related-events.component.html